import React, {useEffect, useState}from 'react'
import './Restaurant.css'
import card1 from '../assets/img/card-img-1.png'
import card2 from '../assets/img/card-img-2.png'
import card3 from '../assets/img/card-img-3.png'
import gallery1 from '../assets/img/gallery-img-1.jpg'
import gallery2 from '../assets/img/gallery-img-2.jpg'
import gallery3 from '../assets/img/gallery-img-3.jpg'
import gallery4 from '../assets/img/gallery-img-4.jpg'
import gallery5 from '../assets/img/gallery-img-5.jpg'
import gallery6 from '../assets/img/gallery-img-6.jpg'

export default function Restaurant() {
    const [galleryDetails, setGalleryDetails] = useState([]);
    const setGalleryObj = function(){
        const galleryImg = [gallery1, gallery2,gallery3, gallery4, gallery5, gallery6];
        const galleryHeader = ["Pancakes", "Cupcakes","Hummus", "Hamburger", "Chawal", "Vegetables"];
        let galleryArr = [];
        for(let i = 0; i< galleryImg.length; i++){
            let tempData = {
                img : galleryImg[i],
                header : galleryHeader[i] 
            }
            galleryArr.push(tempData);
        } 
        setGalleryDetails(galleryArr);
    }
    const menuSlide = function (){
        document.querySelector('.menu').addEventListener('click', () => {
            document.querySelectorAll('.target').forEach((item) => {
                item.classList.toggle('change');
            })
        })
        
        const icons = document.querySelectorAll('.section-1-icons i')
        let i = 1
        
        setInterval(() => {
            i++
            const icon = document.querySelector('.section-1-icons .change')
            icon.classList.remove('change')
        
            if (i > icons.length) {
                icons[0].classList.add('change')
                i = 1
            } else {
                icon.nextElementSibling.classList.add('change')
            }
        }, 3500)
    }
    useEffect(() =>{
        menuSlide();
        setGalleryObj();
    }
    ,[]);

    return (
        <div className="restaurant-section">
            <nav className="navbar target">
                <a href="#" className="navbar-link">
                    <i className="fas fa-home"></i>
                    <span>Home</span>
                </a>
                <a href="#" className="navbar-link">
                    <i className="fas fa-utensils"></i>
                    <span>Meals</span>
                </a>
                <a href="#" className="navbar-link">
                    <i className="fas fa-hamburger"></i>
                    <span>Burger</span>
                </a>
                <a href="#" className="navbar-link">
                    <i className="fas fa-pizza-slice"></i>
                    <span>Pizza</span>
                </a>
                <a href="#" className="navbar-link">
                    <i className="fas fa-blender-phone"></i>
                    <span>Contact</span>
                </a>
            </nav>
            <div className="menu target"></div>
            <section className="section-1">
                <h1 className="section-heading">
                    Delicious Food Place
                </h1>
                <div className="section-1-icons">
                    <i className="change fas fa-pizza-slice"></i>
                    <i className="fas fa-stroopwafel"></i>
                    <i className="fas fa-cheese"></i>
                    <i className="fas fa-hotdog"></i>
                    <i className="fas fa-hamburger"></i>
                    <i className="fas fa-apple-alt"></i>
                    <i className="fas fa-ice-cream"></i>
                    <i className="fas fa-pepper-hot"></i>
                    <i className="fas fa-cookie"></i>
                    <i className="fas fa-seedling"></i>
                </div>
            </section>

            <section className="section-2">
                <h1 className="section-heading">popular meals</h1>
                <div className="cards-container">
                    <div className="card">
                        <img src={card1} className="card-img" />
                        <h3 className="card-name">Fish</h3>
                        <button className="card-btn">Order now</button>
                    </div>
                    <div className="card">
                        <img src={card2} className="card-img" />
                        <h3 className="card-name">Cake</h3>
                        <button className="card-btn">Order now</button>
                    </div>
                    <div className="card">
                        <img src={card3} className="card-img" />
                        <h3 className="card-name">Lobster</h3>
                        <button className="card-btn">Order now</button>
                    </div>
                </div>
            </section>
            <section className="section-3">
                <h1 className="section-heading">Gallery</h1>
                <div className="gallery">
                    {
                        galleryDetails.map((data) => {
                            return (
                                <a href="#" className="gallery-link" title="Order Now">
                                    <img src={data.img} className="food-img" />
                                    <h3 className="food-name">{data.header}</h3>
                                    <p className="food-description">
                                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa
                                        commodi possimus iure hic excepturi. Corporis!
                                    </p>
                                </a>
                            )
                        })
                    }
                </div>
            </section>

            <section className="section-4">
                <div className="section-4-text">
                    <h2 className="section-4-heading">Sign Me Up</h2>
                    <p className="section-4-paragraph">
                        BE THE FIRST TO KNOW ABOUT NEW PRODUCTS
                    </p>
                </div>
                <div className="signup-form ">
                    <input
                        type="email"
                        className="signup-form-input"
                        placeholder="Enter Your Email"
                    />
                    <button type="submit" className="signup-form-btn">
                        <i className="fas fa-arrow-right"></i>
                    </button>
                </div>
                <p className="copyright">BarunPandey.in &copy; All rights reserved</p>
            </section>
        </div>
    )
}
